export const PLACEHOLDER = {
    LOGIN_EMAIL: 'メールアドレス',
    LOGIN_PASSWORD: 'パスワード',

    TEXT: '入力してください',
    SELECT: '選択してください',
    CHAT_MESSAGE: "メッセージを入力",
    PROPERTY_SEARCH_TEXT: "物件名から探す",
    OTP: "0",

    NAME: "例）山田 太郎",
    NAME_KANA: "例）ヤマダ タロウ",
    NICKNAME: "例）タロウ",
    COMPANY_NAME: "例）日本リバックス",
    COMPANY_NAME_KANA: "例）ニッポンリバックス",
    PROPERTY_NAME: "例）ロアール品川",
    POSTCODE: "例）1400011",
    ADDRESS: "例）東京都品川区東大井6-17",
    PHONE_NUMBER: "例）09012345678",
    PHONE_EXT_NUMBER: "例）123",
    EMAIL: "例）yamada@example.com",
    PASSWORD: "入力してください",
    LICENSE_NUMBER: "例）東京都知事(13)第1234543号",
    LIVING_FAMILY_COUNT: "例）2",
    LIVING_CHILDREN_COUNT: "例）1",

    LOAN_INTEREST_RATE: "例）2.00", // 借入金利
    INTEREST_RATE: "例）2.00", // 金利
    ANNUAL_INTEREST: "例）2.00", // 年利
    LOAN_PERIOD: "例）30", // 借入期間
    LOAN_PAYBABLE: "例）20,000,000", // 借入額
    BUILDING_AGE_STANDARD: "例）55", // 築年数基準
    CURRENT_HOLDING_PERIOD: "例）10", // 現在の所有年数
    PERSONAL_FUNDS: "例）1,000,000", // 自己資金
    PERSONAL_FUNDS_THOUSAND: "例）5", // 自己資金（百万円単位）

    RENT: "例）95,000", // 家賃
    COMMON_SERVICE_FEE: "例）7,000", // 共益費
    MANAGEMENT_FEE: "例）10,000", // 管理費
    RESERVE_FUND_FOR_REPAIRS: "例）5,000", // 修繕積立金
    OTHER_EXPENSES: "例）1,000", // その他費用
    MANAGEMENT_FEE_AND_OTHER_EXPENSES: "例）10,000", // 管理費・修繕積立金・その他
    EXPENSE: "例）500,000", // 諸経費
    RENT_CHANGE_SETTING: "例）5.0", // 家賃変動率
    MANAGEMENT_FEE_CHANGE_SETTING: "4,000", // 改修費変動値

    EXPECTED_SALE_PRICE: "例）23,000,000", // 売却予定価格
    DESIRED_SALE_PRICE: "例）2,000", // 売却希望価格
    PURCHASE_PRICE: "例）20,000,000", // 購入価格
    ANNUAL_INCOME: "例）6,000,000", // 年収
    EXISTING_LOAN_AMOUNT: "例）20,000,000", // 既存借入額
    LOAN_RECEIVABLE: "例）10,000,000", // 貸付金

    ROOM_NUMBER: "例）201", // 部屋番号
    OCCUPIED_FLOOR: "例）2", // 専有部分所在階
    OCCUPIED_AREA: "例）20.74", // 専有面積
    BALCONY_AREA: "例）4", // バルコニー面積
    ON_FOOT_TIME: "例）10", // 徒歩分数
    BUILDING_AGE: "例）5", // 築年数

    COST_NOTES: "例）インターネット利用料", // 費用備考
    PEOPERTY_NOTES: "例）2022年4月フルリフォーム済みです。", // 物件備考

    // 反社会勢力に関する同意文
    ANTISOCIAL_TEXT: "１．会員は、次の各号の内容に該当しないことを表明、確約します。\n（１）暴力団、暴力団員及びその構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ、東京都暴力団排除条例の規制対象者、その他これらに準ずる者や企業及び組織。\n（２）前号に該当する者や企業及び組織等と交友関係にある者や企業及び組織。\n（３）現在から将来にわたり、本項１号及び２号に該当する者や企業及び組織等に便宜を供与、または、利益供与等をする関係。\n２．会員は、前項各号に該当する者や企業及び組織等を利用して次の行為を行わないことを確約します。\n（１）暴力的な要求行為。\n（２）法的な責任を超えた不当な要求行為。\n（３）取引に関し脅迫的な言動、または暴力を用いる行為。\n（４）風説を流布し偽計または威力を用いて信用を毀損し、または業務を妨害する行為。\n（５）その他前各号に準じる行為。"
};